import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { environment } from "../../../../../environments/environment";
import {
  VigilantApiDtosOrgsUsersGetResponse,
  VigilantApiDtosRealmAssignRealmRequest,
  VigilantApiDtosRealmUpdateRoleResponse,
  VigilantApiDtosUsersGetResponse,
  VigilantApiDtosUsersOrgsPostRequest,
  VigilantApiDtosUsersPostRequest,
  VigilantApiDtosUsersPutRequest,
  VigilantApiDtosUsersSelfGetResponse
} from "./users.model";
import { VigilantApiDtosOrgsRoleType } from "../orgs/orgs.model";
import { VigilantApiDtosRealmsRoleType } from "../realms/realms.model";
import { UserEventsService } from './user-events.service';

@Injectable({ providedIn: "root" })
export class VigilantUsersService {
  constructor(private http: HttpClient, private userEvents: UserEventsService) { }

  url = environment.vigilantApiUrl;

  getAllActiveUsers(): Observable<VigilantApiDtosUsersGetResponse[]> {
    return this.http.get<VigilantApiDtosUsersGetResponse[]>(`${this.url}/api/Users/active`);
  }

  getUserById(id: number): Observable<VigilantApiDtosUsersGetResponse> {
    return this.http.get<VigilantApiDtosUsersGetResponse>(`${this.url}/api/Users/${id}`);
  }

  getCurrentUser(): Observable<VigilantApiDtosUsersSelfGetResponse> {
    return this.http.get<VigilantApiDtosUsersSelfGetResponse>(`${this.url}/api/Users/self`);
  }

  // createUser(user: VigilantApiDtosUsersPostRequest): Observable<VigilantApiDtosUsersGetResponse> {
  //   return this.http.post<VigilantApiDtosUsersGetResponse>(`${this.url}/api/Users`, user);
  // }

  // updateUser(id: number, user: VigilantApiDtosUsersPutRequest): Observable<VigilantApiDtosUsersGetResponse> {
  //   return this.http.put<VigilantApiDtosUsersGetResponse>(`${this.url}/api/Users/${id}`, user);
  // }

  createUser(
    user: VigilantApiDtosUsersPostRequest
  ): Observable<VigilantApiDtosUsersGetResponse> {
    return this.http
      .post<VigilantApiDtosUsersGetResponse>(`${this.url}/api/Users`, user)
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  updateUser(
    id: number,
    user: VigilantApiDtosUsersPutRequest
  ): Observable<VigilantApiDtosUsersGetResponse> {
    return this.http
      .put<VigilantApiDtosUsersGetResponse>(`${this.url}/api/Users/${id}`, user)
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  deleteUser(id: number): Observable<unknown> {
    return this.http
      .delete<unknown>(`${this.url}/api/Users/${id}`)
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  linkUserToOrg(
    userId: number,
    link: VigilantApiDtosUsersOrgsPostRequest
  ): Observable<VigilantApiDtosOrgsUsersGetResponse> {
    return this.http
      .post<VigilantApiDtosOrgsUsersGetResponse>(
        `${this.url}/api/Users/${userId}/orgs`,
        link
      )
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  unlinkUserToOrg(userId: number, orgId: number): Observable<unknown> {
    return this.http
      .delete<unknown>(`${this.url}/api/Users/${userId}/orgs/${orgId}`)
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  updateUserOrgRole(
    userId: number,
    orgId: number,
    role: VigilantApiDtosOrgsRoleType
  ): Observable<VigilantApiDtosOrgsUsersGetResponse> {
    return this.http
      .patch<VigilantApiDtosOrgsUsersGetResponse>(
        `${this.url}/api/Users/${userId}/orgs/${orgId}/role/${role}`,
        {}
      )
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  updateUserRealmRole(
    userId: number,
    realmId: number,
    role: VigilantApiDtosRealmsRoleType
  ): Observable<VigilantApiDtosRealmUpdateRoleResponse> {
    return this.http
      .patch<VigilantApiDtosRealmUpdateRoleResponse>(
        `${this.url}/api/Users/${userId}/realms/${realmId}/role`,
        { role: role }
      )
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  linkUserToAccount(
    userId: number,
    link: VigilantApiDtosRealmAssignRealmRequest
  ): Observable<VigilantApiDtosRealmUpdateRoleResponse> {
    const realms: VigilantApiDtosRealmAssignRealmRequest[] = [link];

    return this.http
      .post<VigilantApiDtosRealmUpdateRoleResponse>(
        `${this.url}/api/Users/${userId}/realms`,
        realms
      )
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  unlinkUserToAccount(userId: number, realmId: number): Observable<unknown> {
    const realmIds: number[] = [realmId];

    return this.http
      .delete<unknown>(`${this.url}/api/Users/${userId}/realms`, {
        body: realmIds
      })
      .pipe(
        tap(() => this.userEvents.emitUserChanged())
      );
  }

  // linkUserToOrg(userId: number, link: VigilantApiDtosUsersOrgsPostRequest): Observable<VigilantApiDtosOrgsUsersGetResponse> {
  //   return this.http.post<VigilantApiDtosOrgsUsersGetResponse>(`${this.url}/api/Users/${userId}/orgs`, link);
  // }

  // unlinkUserToOrg(userId: number, orgId: number): Observable<unknown> {
  //   return this.http.delete<unknown>(`${this.url}/api/Users/${userId}/orgs/${orgId}`);
  // }

  // updateUserOrgRole(userId: number, orgId: number, role: VigilantApiDtosOrgsRoleType): Observable<VigilantApiDtosOrgsUsersGetResponse> {
  //   return this.http.patch<VigilantApiDtosOrgsUsersGetResponse>(`${this.url}/api/Users/${userId}/orgs/${orgId}/role/${role}`, {});
  // }

  // updateUserRealmRole(userId: number, realmId: number, role: VigilantApiDtosRealmsRoleType): Observable<VigilantApiDtosRealmUpdateRoleResponse> {
  //   return this.http.patch<VigilantApiDtosRealmUpdateRoleResponse>(`${this.url}/api/Users/${userId}/realms/${realmId}/role`, { role: role });
  // }

  // linkUserToAccount(userId: number, link: VigilantApiDtosRealmAssignRealmRequest): Observable<VigilantApiDtosRealmUpdateRoleResponse> {

  //   const realms: VigilantApiDtosRealmAssignRealmRequest[] = [link];
  //   return this.http.post<VigilantApiDtosRealmUpdateRoleResponse>(`${this.url}/api/Users/${userId}/realms`, realms);
  // }

  // unlinkUserToAccount(userId: number, realmId: number): Observable<unknown> {
  //   const realmIds: number[] = [realmId];
  //   return this.http.delete<unknown>(`${this.url}/api/Users/${userId}/realms`, {
  //     body: realmIds
  //   });
  // }
}
